<template>
<div class="chapter">
<div class="inner_page">
<p class="C415"><strong><a id="page_x"></a>Illustrations</strong></p>
<p class="C453"><strong>Maps and diagrams</strong></p>
<p class="P22"><a href="#/Text/08_1The_historical_context_of_Jesus#page_16">Palestine in New Testament times </a></p>
<p class="P22"><a href="#/Text/08_1The_historical_context_of_Jesus#id_187">Jerusalem at the time of Jesus </a></p>
<p class="P22"><span href="#/Text/09_2Judaism_in_first_century_Palest#page_34" title="Link target outside of Sample">The Temple Mount AD 70 </span></p>
<p class="P22"><span href="#/Text/09_2Judaism_in_first_century_Palest#id_188" title="Link target outside of Sample">The Herodian temple area </span></p>
<p class="P22"><span href="#/Text/24_13Acts#id_189" title="Link target outside of Sample">Paul’s first journey </span></p>
<p class="P22"><span href="#/Text/24_13Acts#id_190" title="Link target outside of Sample">Paul’s second journey </span></p>
<p class="P22"><span href="#/Text/24_13Acts#id_191" title="Link target outside of Sample">Paul’s third journey </span></p>
<p class="P22"><span href="#/Text/24_13Acts#id_192" title="Link target outside of Sample">Paul’s journey to Rome </span></p>
<p class="C453"><strong>Charts and tables</strong></p>
<p class="P22"><a href="#/Text/08_1The_historical_context_of_Jesus#page_8">Key dates and events in the second temple period </a></p>
<p class="P22"><a href="#/Text/08_1The_historical_context_of_Jesus#id_193">Key dates from the OT to the Roman takeover </a></p>
<p class="P22"><a href="#/Text/08_1The_historical_context_of_Jesus#id_194">Hasmonean leaders of Judea 167-63 BC </a></p>
<p class="P22"><a href="#/Text/08_1The_historical_context_of_Jesus#id_195">Herod family: a selective family tree </a></p>
<p class="P22"><a href="#/Text/08_1The_historical_context_of_Jesus#id_196">Leaders/rulers of Judea in the Roman period </a></p>
<p class="P22"><a href="#/Text/08_1The_historical_context_of_Jesus#id_197">Roman leaders/emperors </a></p>
<p class="P22"><a href="#/Text/08_1The_historical_context_of_Jesus#id_198">Key dates in the Roman period </a></p>
<p class="P22"><span href="#/Text/12_4Where_did_the_Gospels_come_from#id_199" title="Link target outside of Sample">Agreements in sequence: an example </span></p>
<p class="P22"><span href="#/Text/12_4Where_did_the_Gospels_come_from#id_200" title="Link target outside of Sample">The sequence of Q </span></p>
<p class="P22"><span href="#/Text/12_4Where_did_the_Gospels_come_from#id_201" title="Link target outside of Sample">Matthew’s sermon on the mount material in Luke</span></p>
<p class="P22"><span href="#/Text/12_4Where_did_the_Gospels_come_from#id_202" title="Link target outside of Sample">Alternating support: an example </span></p>
<p class="P22"><span href="#/Text/20_10Matthew#id_203" title="Link target outside of Sample">Sermon on the mount </span></p>
<p class="P22"><span href="#/Text/21_11Luke#id_204" title="Link target outside of Sample">Luke and his sources </span></p>
<p class="P22"><span href="#/Text/24_13Acts#id_205" title="Link target outside of Sample">Prophecy and fulfilment: some examples</span></p>
<p class="P22"><span href="#/Text/24_13Acts#id_206" title="Link target outside of Sample">Acts as fulfilment of 1:8 </span></p>
<p class="P22"><span href="#/Text/24_13Acts#page_336" title="Link target outside of Sample">A chronological outline of Acts </span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_List_of_illustrations.vue?04e9118c